"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-kit/redux/form/actions");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var formConfig = {
  name: "propertyRegistrationDetails",
  fields: {
    dag: {
      id: "dag",
      jsonPath: "Properties[0].registrationDetails.dag",
      type: "textfield",
      floatingLabelText: "Dag",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      fullWidth: true,
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "dag", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.dag", field.value));
      }
    },
    khatian: {
      id: "khatian",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.khatian",
      floatingLabelText: "Khatian",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "khatian", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.khatian", field.value));
      }
    },
    mouza: {
      id: "mouza",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.mouza",
      floatingLabelText: "Mouza",
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "mouza", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.mouza", field.value));
      },
      numcols: 6
    },

    queryNo: {
      id: "queryNo",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.queryNo",
      floatingLabelText: "Query Number",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "queryNo", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.queryNo", field.value));
      }
    },
    queryYear: {
      id: "queryYear",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.queryYear",
      floatingLabelText: "Query Year",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "queryYear", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.queryYear", field.value));
      }
    },
    deedNo: {
      id: "deedNo",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.deedNo",
      floatingLabelText: "Deed Number",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "deedNo", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.deedNo", field.value));
      }
    },
    deedYear: {
      id: "deedYear",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.deedYear",
      floatingLabelText: "Deed Year",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "deedYear", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.deedYear", field.value));
      }
    },
    location: {
      id: "location",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.location",
      floatingLabelText: "Location",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref8) {
        var formKey = _ref8.formKey,
            field = _ref8.field,
            dispatch = _ref8.dispatch,
            state = _ref8.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "location", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.location", field.value));
      }
    },
    ro: {
      id: "ro",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.ro",
      floatingLabelText: "RO",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref9) {
        var formKey = _ref9.formKey,
            field = _ref9.field,
            dispatch = _ref9.dispatch,
            state = _ref9.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "ro", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.ro", field.value));
      }
    },
    book: {
      id: "book",
      type: "textfield",
      jsonPath: "Properties[0].registrationDetails.book",
      floatingLabelText: "Book",
      numcols: 6,
      updateDependentFields: function updateDependentFields(_ref10) {
        var formKey = _ref10.formKey,
            field = _ref10.field,
            dispatch = _ref10.dispatch,
            state = _ref10.state;

        dispatch((0, _actions.setFieldProperty)("propertyRegistrationDetails", "book", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].registrationDetails.book", field.value));
      }
    }
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/propertyRegistrationDetails.js
// module id = 1687
// module chunks = 1137